import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { IService } from 'app/services/models/service';
import { IUser } from 'app/shared/Domains/IUser';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from '@fullcalendar/interaction';
import { ISubscription } from 'app/services/models/subscription';
import { ISubscriptionFee } from 'app/services/models/subscriptionFee';
import { ISubscriptionSessions } from 'app/services/models/subscriptionSessions';
import { LanguageService } from 'app/LanguageService/Language.Service';
import { ICompany } from 'app/shared/Domains/company';
import { IBranch } from "app/shared/Domains/branch";
import { ChartConfiguration, ChartData, ChartType } from 'chart.js';
import {
  Chart as ChartJS,
  PointElement,
  BubbleController
} from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import DataLabelsPlugin from 'chartjs-plugin-datalabels';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

ChartJS.register(
  PointElement,
  BubbleController,
  annotationPlugin
);

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  loading: boolean = false;
  currentChurnRateKPIValue: string = '';
  lastChurnRateKPIValue: string = '';
  diffChurnRateKPIValue: string = '';
  churnRateStatus: string = "NoDiff";
  expandChurnRateKPI: boolean = false;
  currentActiveMembersRateKPIValue: string = '';
  lastActiveMembersKPIValue: string = '';
  diffActiveMembersKPIValue: string = '';
  activeMembersStatus: string = "NoDiff";
  currentNewMembersRateKPIValue: string = '';
  lastNewMembersKPIValue: string = '';
  diffNewMembersKPIValue: string = '';
  newMembersStatus: string = "NoDiff";
  currentSalesRateKPIValue: string = '';
  lastSalesKPIValue: string = '';
  diffSalesKPIValue: string = '';
  salesStatus: string = "NoDiff";
  currentDayPassKPIValue: string = '';
  lastDayPassKPIValue: string = '';
  diffDayPassKPIValue: string = '';
  dayPassStatus: string = "NoDiff";
  currentMembershipFrozenKPIValue: string = '';
  lastMembershipFrozenKPIValue: string = '';
  diffMembershipFrozenKPIValue: string = '';
  membershipFrozenStatus: string = "NoDiff";
  currentTrainerSalesKPIValue: string = '';
  lastTrainerSalesKPIValue: string = '';
  diffTrainerSalesKPIValue: string = '';
  trainerSalesStatus: string = "NoDiff";
  currentPOSSalesKPIValue: string = '0';
  lastPOSSalesKPIValue: string = '0';
  diffPOSSalesKPIValue: string = '0';
  posSalesStatus: string = "NoDiff";
  kpiMainState: string = "";
  churnRateValue: number = 0;
  churnRateChartLabel: string = '';
  chartLabelSummary: string = '';
  NewMembersRegisteredCount: string = '';
  totalPackageAmountForChart: string = '';
  monthOptions: any[] = [];
  yearOptions: any[] = [];
  statusOptions: any[] = [];
  typeOptions: any[] = [];
  monthValue: string = '';
  yearValue: string = '';
  statusValue: string = '';
  typeValue: string = '';
  company: ICompany = new ICompany();
  companySessionStorage: any;
  branchSessionStorage: any;
  currentUser: string = '';
  branch: IBranch = new IBranch();
  data: any;
  previousYearSales : any;
  currentYearSales : any;
  currentYear : any;
  previousYear : any;
  totalPosSales: number = 0;
  totalPosProfit: number = 0;
  showPosNetProfit: boolean = false;
  isAllowDashboardCharts : boolean = false;
  showChurnRateCard: boolean = false;
  private readonly SHARING_BRANCH_ID = '67728682419e66d9220356ec';
  //These variables are used to determine the text & UI size of Charts Js
  isMobile: boolean = window.innerWidth <= 500;
  isSmallMobile: boolean = window.innerWidth <= 375;
  isTablet: boolean = window.innerWidth <= 1000 && window.innerWidth > 500;
  isSmallLaptop: boolean = window.innerWidth <= 1500 && window.innerWidth > 1280;
  isDesktopView: boolean = window.innerWidth > 1820;

  public ChurnRateChartType: ChartType = 'doughnut';
  public ChurnRateChartData!: ChartData<'doughnut'>;
  public ChurnRateChartOptions!: ChartConfiguration['options'];

  COLORS = ['rgb(140, 214, 16)', 'rgb(239, 198, 0)', 'rgb(231, 24, 49)'];

  public ActiveMembersChartType: ChartType = 'bar';
  public ActiveMembersChartData!: ChartData<'bar'>;
  public ActiveMembersChartOptions!: ChartConfiguration<'bar'>['options'];
  public ActiveMembersDataLabels = DataLabelsPlugin;

  public NewMembersRegisteredChartType: ChartType = 'doughnut';
  public NewMembersRegisteredChartData!: ChartData<'doughnut'>;
  public NewMembersRegisteredChartOptions!: ChartConfiguration<'doughnut'>['options'];
  public NewMembersRegisteredDataLabels = DataLabelsPlugin;

  public DailyMemberAttendanceChartType: ChartType = 'line';
  public DailyMemberAttendanceChartData!: ChartData<'line'>;
  public DailyMemberAttendanceChartOptions!: ChartConfiguration<'line'>['options'];
  public DailyMemberAttendanceDataLabels = DataLabelsPlugin;

  public monthWiseSalesChartType: ChartType = 'line';
  public monthWiseSalesChartData!: ChartData<'line'>;
  public monthWiseSalesChartOptions!: ChartConfiguration<'line'>['options'];
  public monthWiseSalesChartLabels: string[] = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  public monthWiseSalesDataLabels = DataLabelsPlugin;
  public monthWiseSalesChartTitle = "";

  public packageWiseSalesChartType: ChartType = 'doughnut';
  public packageWiseSalesChartData!: ChartData<'doughnut'>;
  public packageWiseSalesChartOptions!: ChartConfiguration<'doughnut'>['options'];
  public packageWiseSalesChartLabels: string[] = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  public packageWiseSalesDataLabels = DataLabelsPlugin;



  constructor(
    private LanguageService: LanguageService,
    private breadcrumbService: BreadcrumbService,
    private router: Router,
    public confirmationService: ConfirmationService,
    private appServiceManager: AppServiceManager,
    private route: ActivatedRoute,
    private messageService: MessageService
  ) {
    this.breadcrumbService.setItems([
      { label: 'Dashboard', routerLink: "/dashboard" },
      { label: "Dashboard" }
    ]);
  }
  ngOnInit() {
    this.currentUser = localStorage.getItem('currentUser') || '';
    const currentUseroBJ = JSON.parse(this.currentUser);
    this.companySessionStorage = currentUseroBJ.company;
    this.branchSessionStorage = currentUseroBJ.branch;
    this.monthOptions = [
      { label: "January", value: '1' },
      { label: "February", value: '2' },
      { label: "March", value: '3' },
      { label: "April", value: '4' },
      { label: "May", value: '5' },
      { label: "June", value: '6' },
      { label: "July", value: '7' },
      { label: "August", value: '8' },
      { label: "September", value: '9' },
      { label: "October", value: '10' },
      { label: "November", value: '11' },
      { label: "December", value: '12' }
    ];

    const currentYear = new Date().getFullYear();
    const startYear = currentYear - 5;
    const endYear = currentYear;
    this.company = new ICompany();
    this.branch = AuthService.getLoggedInCurrentBranch();
    this.isAllowDashboardCharts = this.branch.permissions?.isAllowDashboardCharts ?? false;
    this.showChurnRateCard = this.branch?._id === this.SHARING_BRANCH_ID;
    this.yearOptions = [];
    for (let year = startYear; year <= endYear; year++) {
      this.yearOptions.push({ label: year.toString(), value: year.toString() });
    }

    this.statusOptions = [
      { label: "All", value: 'All' },
      { label: "Approved", value: 'Approved' },
      { label: "Pending", value: 'Pending' },
      { label: "Reject", value: 'Reject' }
    ];
    this.typeOptions = [
      { label: "All", value: 'All' },
      { label: "Visitor", value: 'Visitor' },
      { label: "Registration", value: 'Registration' },
      { label: "Fee Submission", value: 'Fee Submission' }
    ];
    this.data = {
      totalSales: 0,
      newMemberRegistered: 0,
      defaulters: 0,
      activeCustomers: 0,
      activemembersthismonth:10,
      visitors: 0,
      enquiries: 0,
    };
    this.statusValue = 'All';
    this.typeValue = 'All';
    const dateNow = new Date();
    this.monthValue = (dateNow.getMonth() + 1).toString(); // getMonth() returns 0-11, so add 1
    this.yearValue = currentYear.toString();
    this.getUpdatedData();

    if (this.showChurnRateCard) {
      this.getChurnRateData();
    }
    this.getTotalSalesData();
    this.getTotalPosSales();
    this.getNewMembersStats();
    this.getDayPassStats();
    this.getFrozenMemberStats();
    this.getAttendanceData();
    this.getTrainerStatus();
    this.getActiveMembersStatus();
    this.getMonthWiseSalesChartData();
    this.getPackageWiseSalesChartData();
    this.getNewMembersRegisteredChartData();
    this.getTotalActiveMembersStatus();


  }

  getAttendanceData() {
    this.loading = true;
    this.appServiceManager.get(
      `branches/${this.branch._id}/stats-dashboards/reports/attendance-stats/month/${this.monthValue}/year/${this.yearValue}`,
    ).subscribe(
      (res: any) => {
        if (res) {

          this.drawDailyMemberAttendanceChart(res);
        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error: any) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }
  drawMonthWiseSaleChart(){

     let currentYear = this.currentYear + " Sales";
    let LastYear = this.previousYear + " Sales";

    this.monthWiseSalesChartTitle = "2025-26";

    let currentYearData = this.currentYearSales;
    let LastYearData = this.previousYearSales;

    const allValues = [...LastYearData, ...currentYearData];

    let minValue = allValues[0];
    let maxValue = allValues[0];

    allValues.forEach(val => {
      if (val != null){
        if (val < minValue){
          minValue = val;
        }
        if (val > maxValue){
          maxValue = val;
        }
      }
    });

  this.monthWiseSalesChartData = {
    labels: this.monthWiseSalesChartLabels,
    datasets: [
      {
        data: currentYearData,
        label: currentYear,
        borderColor: '#42A5F5',
        backgroundColor: 'rgba(66, 165, 245, 0.2)',
        tension: 0.4,
        fill: false,
      },
      {
        data: LastYearData,
        label: LastYear,
        borderColor: '#9CCC65',
        backgroundColor: 'rgba(156, 204, 101, 0.2)',
        tension: 0.4,
        fill: false,
      }
    ]
  };

  this.monthWiseSalesChartOptions = {
    responsive: true,
    plugins: {
      tooltip: {
        enabled: false
      },
      legend: {
        display: true,
        position: 'top',

      },
  // @ts-ignore
      datalabels: {
      display: true,
      anchor: (ctx) => {
        return ctx.dataset.label === currentYear ? 'end' : 'start';
      },
      align: (ctx) => {
        return ctx.dataset.label === currentYear ? 'top' : 'bottom';
      },
      formatter: (value: number) => {
        if (value >= 1_000_000_000) return (value / 1_000_000_000).toFixed(1) + 'B';
        if (value >= 1_000_000) return (value / 1_000_000).toFixed(1) + 'M';
        if (value >= 1_000) return (value / 1_000).toFixed(1) + 'K';
        return value;
      },
      font: {
        weight: 'bold',
        size: this.isMobile? 7 : (this.isTablet ? 10: 14),
      }
    }
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: this.isMobile ? 12 : (this.isTablet ? 12: 14)
          }
        }
      },
      y: {
        beginAtZero: false,
        suggestedMin: minValue - 10,
        suggestedMax: maxValue + 2000000,
        ticks: {
          callback: (value: string | number) => {
            const num = Number(value);
            if (num >= 1_000_000_000) return (num / 1_000_000_000) + 'B';
            if (num >= 1_000_000) return (num / 1_000_000) + 'M';
            if (num >= 1_000) return (num / 1_000) + 'K';
            return value;
          },
          font: {
          weight: 'bold',
          size: this.isMobile? 8 :(this.isTablet ? 10: 14),

        }, padding:this.isMobile? 10 :(this.isTablet ? 10: 5),
        }
      }
    }
  };
  }

drawPackageWiseSales(packageData: any) {
  const packagesData = packageData;

  const labels = packagesData.map((pkg: any) => pkg.packageName);
  const data = packagesData.map((pkg: any) => pkg.packageCurrentData);
  const backgroundColors = packagesData.map((pkg: any) => pkg.color);

  this.packageWiseSalesChartData = {
    labels,
    datasets: [
      {
        label: 'Total Sales by Package',
        data,
        backgroundColor: backgroundColors,
      }
    ]
  };

  this.packageWiseSalesChartOptions = {
    responsive: true,
    cutout: '50%',
  layout: {
    // padding: {
    //   top: 5,
    //   bottom: 5,
    //   left: 5,
    //   right: 5
    // }
  },
    plugins: {
      tooltip: {
        enabled: false,
      },
      legend: {
        display: true,
        position:'bottom',
        align:'start',
        labels: {
          usePointStyle: true,
          pointStyle:'rectRot',
          padding: this.isSmallMobile? 10 : 20,
          font: {
            size: this.isMobile? 12 : (this.isTablet ? 10: 12),
          }
        }
      },
      datalabels: {
        anchor: 'center',
        align: 'center',
        display: true,
      clamp: true, // Ensures label stays within chart area
      clip: false,
        formatter: (value: number, context: any) => {
          let formattedValue = value.toString();
          if (value >= 1_000_000_000) formattedValue = (value / 1_000_000_000).toFixed(1) + 'B';
          else if (value >= 1_000_000) formattedValue = (value / 1_000_000).toFixed(1) + 'M';
          else if (value >= 1_000) formattedValue = (value / 1_000).toFixed(1) + 'K';

          const label = context.chart.data.labels[context.dataIndex];
          return ` ${formattedValue}`;
        },
        color: '#000',
        font: {
          weight: 'bold',
          family: 'sans-serif',
          size: this.isMobile? 10 : (this.isTablet ? 12: (this.isSmallLaptop ?  10: 14)),
        }
      }
    }
  };
}

  getRandomValue(min: number, max: number): number {
    return Math.random() * (max - min) + min;
  }

  index(perc: number): number {
    return perc < 10 ? 0 : perc < 50 ? 1 : 2;
  }

  drawChurnRateKpi(lastValue: any, currentValue: any) {
    if (lastValue == undefined && currentValue != undefined) {
      this.currentChurnRateKPIValue = currentValue.toFixed(2) + "%";
      this.lastChurnRateKPIValue = "No Data";
      this.diffChurnRateKPIValue = currentValue.toFixed(2) + "%";
      this.churnRateStatus = "churnRateUp";
    }
    else if (currentValue == undefined && lastValue != undefined) {
      this.currentChurnRateKPIValue = "No Data";
      this.lastChurnRateKPIValue = lastValue.toFixed(2) + "%";
      this.diffChurnRateKPIValue = lastValue.toFixed(2) + "%";
      this.churnRateStatus = "churnRateDown";
    }
    else if (currentValue == undefined && lastValue == undefined) {
      this.currentChurnRateKPIValue = "No Data";
      this.lastChurnRateKPIValue = "No Data";
      this.diffChurnRateKPIValue = "0";
      this.churnRateStatus = "NoDiff";
    }
    else {
      this.currentChurnRateKPIValue = currentValue.toFixed(2) + "%";
      this.lastChurnRateKPIValue = lastValue.toFixed(2) + "%";

      if (currentValue > lastValue) {
        let diff = currentValue - lastValue;
        this.diffChurnRateKPIValue = diff.toFixed(2) + "%";
        this.churnRateStatus = "churnRateUp";
      }
      else if (lastValue > currentValue) {
        let diff = lastValue - currentValue;
        this.diffChurnRateKPIValue = diff.toFixed(2) + "%";
        this.churnRateStatus = "churnRateDown";
      }
      else {
        this.diffChurnRateKPIValue = "0";
        this.churnRateStatus = "NoDiff";
      }
    }
  }

  drawMembershipFrozenKpi(currentValue: any, lastValue: any){

  if(lastValue == undefined && currentValue != undefined){
      this.currentMembershipFrozenKPIValue = currentValue.toString();
      this.lastMembershipFrozenKPIValue = "No Data";
      this.diffMembershipFrozenKPIValue = currentValue.toString();
      this.membershipFrozenStatus = "frozenMemberUp";
    }
    else if (currentValue == undefined && lastValue != undefined){
        this.currentMembershipFrozenKPIValue = "No Data";
        this.lastMembershipFrozenKPIValue = lastValue.toString();
        this.diffMembershipFrozenKPIValue =  lastValue.toString();
        this.membershipFrozenStatus = "frozenMemberDown";
    }
    else if (currentValue == undefined && lastValue == undefined) {
      this.currentMembershipFrozenKPIValue = "No Data";
      this.lastMembershipFrozenKPIValue = "No Data";
      this.diffMembershipFrozenKPIValue = "0";
      this.membershipFrozenStatus = "NoDiff";
    }
    else{
      this.currentMembershipFrozenKPIValue = currentValue.toString();
      this.lastMembershipFrozenKPIValue = lastValue.toString();

      if(currentValue > lastValue){
        let diff = currentValue - lastValue;
        this.diffMembershipFrozenKPIValue = diff.toString();
        this.membershipFrozenStatus = "frozenMemberUp";
      }
      else if(lastValue > currentValue){
        let diff = lastValue - currentValue;
        this.diffMembershipFrozenKPIValue = diff.toString();
        this.membershipFrozenStatus = "frozenMemberDown";
      }
      else{
        this.diffMembershipFrozenKPIValue =  "0";
        this.membershipFrozenStatus = "NoDiff";
      }
    }
  }

  drawChurnRateChart(currentValue: any, lastMonthValue: any){
    if(typeof(currentValue) != "number"){
      currentValue = Number(currentValue);
    }

    if(typeof(lastMonthValue) != "number"){
      lastMonthValue = Number(lastMonthValue);
    }

    const perc = currentValue;
    this.churnRateValue = currentValue;
    this.churnRateChartLabel = currentValue.toFixed(0) +"%";
    if(currentValue > lastMonthValue){
      let diff = currentValue - lastMonthValue;
      this.chartLabelSummary = diff.toFixed(2) +"% higher than last month.";
    }
    else if(lastMonthValue > currentValue){
      let diff = lastMonthValue - currentValue;
      this.chartLabelSummary = diff.toFixed(2) +"% lower than last month.";
    }
    else{
      this.chartLabelSummary = "unchanged from last month.";
    }
    this.ChurnRateChartData = {
      datasets: [{
        data: [perc, 100 - perc],
        backgroundColor: (ctx: any) => {
          if (ctx.index === 1) return 'rgb(234, 234, 234)';
          return this.COLORS[this.index(ctx.raw)];
        }
      }]
    };

    this.ChurnRateChartOptions = {
      responsive: true,
      aspectRatio: 2,
  // @ts-ignore
      cutout: '86%',
  // @ts-ignore
    circumference: 180,
  // @ts-ignore
    rotation: -90,
      plugins: {
        annotation: {
          annotations: {
            label: {
              // @ts-ignore
              enabled: false
            }
          }
        }
      }
    };
  }

  getChurnRateStyle() {
    const num = Number(this.churnRateValue);
    if (isNaN(num)) return {};

    return { color: this.COLORS[this.index(this.churnRateValue)] };
  }

  drawActiveMembersKpi(currentValue: any, lastValue: any){
    if (lastValue == undefined && currentValue != undefined) {
      this.currentActiveMembersRateKPIValue = currentValue.toString();
      this.lastActiveMembersKPIValue = "No Data";
      this.diffActiveMembersKPIValue = currentValue.toString();
      this.activeMembersStatus = "activeMemberUp";
    }
    else if (currentValue == undefined && lastValue != undefined) {
      this.currentActiveMembersRateKPIValue = "No Data";
      this.lastActiveMembersKPIValue = lastValue.toString();
      this.diffActiveMembersKPIValue = lastValue.toString();
      this.activeMembersStatus = "activeMemberDown";
    }
    else if (currentValue == undefined && lastValue == undefined) {
      this.currentActiveMembersRateKPIValue ="No Data";
      this.lastActiveMembersKPIValue ="No Data";
      this.diffActiveMembersKPIValue = "0";
      this.activeMembersStatus = "NoDiff";
    }
    else {
      this.currentActiveMembersRateKPIValue = currentValue.toString();
      this.lastActiveMembersKPIValue = lastValue.toString();

      if (currentValue > lastValue) {
        let diff = currentValue - lastValue;
        this.diffActiveMembersKPIValue = diff.toString();
        this.activeMembersStatus = "activeMemberUp";
      }
      else if (lastValue > currentValue) {
        let diff = lastValue - currentValue;
        this.diffActiveMembersKPIValue = diff.toString();
        this.activeMembersStatus = "activeMemberDown";
      }
      else {
        this.diffActiveMembersKPIValue = "0";
        this.activeMembersStatus = "NoDiff";
      }
    }

  }

  drawActiveMembersChart(activeMembersData: any){
    let labels: any[] = [];
    let data: any[] = [];
    activeMembersData.forEach((activeMemberData: any) => {
      labels.push(activeMemberData.label);
      data.push(activeMemberData.value.toFixed(0));
    });

    this.ActiveMembersChartData = {
    labels: labels,
    datasets: [
      {
        data: data,
        label: 'Active Members',
        borderColor: 'blue',
        backgroundColor: 'blue'
      }
    ]
  };

  this.ActiveMembersChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: 'y',
    scales: {
      x: {
        ticks: {
          font: {
            size: this.isMobile ? 8 : (this.isTablet ? 10: 14) ,
            weight: 'bold'
          },
        }
      },
      y: {
        ticks: {
          autoSkip: false, // ensures all labels show
          font: {
            size: this.isMobile ? 8 : (this.isTablet ? 10: 14),
            weight: 'bold'
          },
        }
      }
    },
    plugins: {
      tooltip: {
        enabled: false
      },
      legend: { display: false },
  // @ts-ignore
      datalabels:{
        display: true,
        color: '#fff',
        padding:20,
        font: {
          weight: 'bold',
          size: this.isMobile ? 8 :  (this.isTablet ? 10: 12),
        }
      }
    }
  };

    setTimeout(() => {
        const activeChartContainer = document.getElementById("activeChartContainer");
        if (activeChartContainer) {
          activeChartContainer.style.height = this.isDesktopView ? '690px' : '523px';
        }
    }, 10);
  }

  drawDayPassKpi(currentValue: any, lastValue: any){
    if(lastValue == undefined && currentValue != undefined){
      this.currentDayPassKPIValue = currentValue.toString();
      this.lastDayPassKPIValue = "No Data";
      this.diffDayPassKPIValue = currentValue.toString();
      this.dayPassStatus = "salesUp";
    }
    else if (currentValue == undefined && lastValue != undefined){
        this.currentDayPassKPIValue = "No Data";
        this.lastDayPassKPIValue = lastValue.toString();
        this.diffDayPassKPIValue =  lastValue.toString();
        this.dayPassStatus = "salesDown";
    }
    else if (currentValue == undefined && lastValue == undefined){
        this.currentDayPassKPIValue = "No Data";
        this.lastDayPassKPIValue = "No Data";
        this.diffDayPassKPIValue =  "0";
        this.dayPassStatus = "NoDiff";
    }
    else{
      this.currentDayPassKPIValue = currentValue.toString();
      this.lastDayPassKPIValue = lastValue.toString();

      if(currentValue > lastValue){
        let diff = currentValue - lastValue;
        this.diffDayPassKPIValue = diff.toString();
        this.dayPassStatus = "salesUp";
      }
      else if(lastValue > currentValue){
        let diff = lastValue - currentValue;
        this.diffDayPassKPIValue = diff.toString();
        this.dayPassStatus = "salesDown";
      }
      else{
        this.diffDayPassKPIValue =  "0";
        this.dayPassStatus = "NoDiff";
      }
    }
  }

  drawNewMembersRegisteredChart(newMembersRegisteredData: any){
    let labels: any[] = [];
    let data: any[] = [];
    let total = 0;
    newMembersRegisteredData.forEach((newMemberRegisteredData: any) => {
      labels.push(newMemberRegisteredData.label);
      data.push(newMemberRegisteredData.value.toFixed(0));
      total += newMemberRegisteredData.value;
    });

  const backgroundColors = newMembersRegisteredData.map((pkg: any) => pkg.color);

    this.NewMembersRegisteredCount = total.toFixed(0);

    this.NewMembersRegisteredChartData = {
    labels: labels,
    datasets: [
      {
        data: data,
        backgroundColor: backgroundColors,
      }
    ]
  };
    this.NewMembersRegisteredChartOptions = {
    responsive: true,
    cutout: '50%',
  layout: {
    // padding: {
    //   top: 20,
    //   bottom: 20,
    //   left: 20,
    //   right: 20
    // }
  },
    plugins: {
      tooltip: {
        enabled: false
      },
      legend: {
        display: true,
        position: 'bottom',
        align:'start',
        labels: {
          usePointStyle: true,
          pointStyle: 'rectRot',
          padding: 20,
          font: {
            size: 12,
          }
        }
      },
      datalabels: {
        anchor: 'center',
        align: 'center',
        display: true,
      clamp: true, // Ensures label stays within chart area
      clip: false,
        formatter: (value: number, context: any) => {
          let formattedValue = value.toString();
          const label = context.chart.data.labels[context.dataIndex];
          return `${formattedValue}`;
        },
        color: '#000',
        font: {
          weight: 'bold',
          family: 'sans-serif',
          size: this.isMobile? 10 : (this.isTablet ? 14: 14),
        }
      }
    }
  };
  }

  drawDailyMemberAttendanceChart(activeMembersData: any){
    let labels: any[] = [];
    let data: any[] = [];
    let allValues: any[] = [];
    activeMembersData.forEach((activeMemberData: any) => {
      labels.push(activeMemberData.label);
      if(activeMemberData.value == null){
      data.push(null);
      }
      else{
      data.push(activeMemberData.value.toFixed(0));
      }

      allValues.push(activeMemberData.value);
    });

    let minValue = allValues[0];
    let maxValue = allValues[0];

    allValues.forEach(val => {
      if (val != null){
        if (val < minValue){
          minValue = val;
        }
        if (val > maxValue){
          maxValue = val;
        }
      }
    });

    this.DailyMemberAttendanceChartData = {
    labels: labels,
    datasets: [
      {
        data: data,
        label: 'Active Members',
        fill: false,
        tension: this.isMobile? 0.1 : (this.isTablet ? 0.1: 0.4),
        borderColor: 'blue',
        backgroundColor: 'rgba(0,0,255,0.1)',
      }
    ]
  };

  this.DailyMemberAttendanceChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        enabled: false
      },
      legend: { display: false },
  // @ts-ignore
      datalabels:{
        anchor: 'start',
        align: 'top',
        display: true,
        formatter: (value: number) => {
          return value;
        },
        color: '#000',
        padding: 2,
        font: {
          weight: 'bold',
          size: this.isMobile? 6 : (this.isTablet ? 10: 14),
        }
      }
    },
    scales: {
            x: {
            ticks: {
              font: {
                size: this.isMobile ? 10 : (this.isTablet ? 12: 14),
              }
            }
      },
      y: {
        beginAtZero: false,
        suggestedMin: minValue - 10,
        suggestedMax: maxValue + 10,
          ticks: {
              font: {
                size: this.isMobile ? 10 : (this.isTablet ? 12: 14),
              }
            }
      },
    }
  };
    setTimeout(() => {
      const memberAttendenceChart = document.getElementById("memberAttendencechartid");
      if (memberAttendenceChart) {
        memberAttendenceChart.style.height = '250px';
      }
    }, 10);
  }

  drawSalesKpi(currentValue: any, lastValue: any){

    if(lastValue == undefined && currentValue != undefined){
      this.currentSalesRateKPIValue = currentValue.toString();
      this.lastSalesKPIValue = lastValue;

      this.diffSalesKPIValue = currentValue.toString();
      this.salesStatus = "salesUp";
    }
    else if (currentValue == undefined && lastValue != undefined){
        this.currentSalesRateKPIValue = currentValue;
        this.lastSalesKPIValue = lastValue.toString();
        this.diffSalesKPIValue =  lastValue.toString();
        this.salesStatus = "salesDown";
    }
    else if (currentValue == undefined && lastValue == undefined){
        this.currentSalesRateKPIValue = currentValue;
        this.lastSalesKPIValue = lastValue;
        this.diffSalesKPIValue =  "0";
        this.salesStatus = "NoDiff";
    }
    else{
      this.currentSalesRateKPIValue = currentValue.toString();
      this.lastSalesKPIValue = lastValue.toString();

      if(currentValue > lastValue){
        let diff = currentValue - lastValue;
        this.diffSalesKPIValue = diff.toString();
        this.salesStatus = "salesUp";
      }
      else if(lastValue > currentValue){
        let diff = lastValue - currentValue;
        this.diffSalesKPIValue = diff.toString();
        this.salesStatus = "salesDown";
      }
      else{
        this.diffSalesKPIValue =  "0";
        this.salesStatus = "NoDiff";
      }
    }
  }

  drawNewMembersKpi(currentValue: any, lastValue: any){
   if(lastValue == undefined && currentValue != undefined){
      this.currentNewMembersRateKPIValue = currentValue.toString();
      this.lastNewMembersKPIValue = "No Data";
      this.diffNewMembersKPIValue = currentValue.toString();
      this.newMembersStatus = "newMemberUp";
    }
    else if (currentValue == undefined && lastValue != undefined){
        this.currentNewMembersRateKPIValue = "No Data";
        this.lastNewMembersKPIValue = lastValue.toString();
        this.diffNewMembersKPIValue =  lastValue.toString();
        this.newMembersStatus = "newMemberDown";
    }
    else if (currentValue == undefined && lastValue == undefined){
        this.currentNewMembersRateKPIValue = "No Data";
        this.lastNewMembersKPIValue = "No Data";
        this.diffNewMembersKPIValue = "0";
        this.newMembersStatus = "NoDiff";
    }
    else{
      this.currentNewMembersRateKPIValue = currentValue.toString();
      this.lastNewMembersKPIValue = lastValue.toString();

      if(currentValue > lastValue){
        let diff = currentValue - lastValue;
        this.diffNewMembersKPIValue = diff.toString();
        this.newMembersStatus = "newMemberUp";
      }
      else if(lastValue > currentValue){
        let diff = lastValue - currentValue;
        this.diffNewMembersKPIValue = diff.toString();
        this.newMembersStatus = "newMemberDown";
      }
      else{
        this.diffNewMembersKPIValue =  "0";
        this.newMembersStatus = "NoDiff";
      }
    }


  }

  drawTrainerSaleKpi(currentValue: any, lastValue: any) {
    if (lastValue == undefined && currentValue != undefined) {
      this.currentTrainerSalesKPIValue = currentValue.toString();
      this.lastTrainerSalesKPIValue = lastValue;

      this.diffTrainerSalesKPIValue = currentValue.toString();
      this.trainerSalesStatus = "newMemberUp";
    }
    else if (currentValue == undefined && lastValue != undefined) {
      this.currentTrainerSalesKPIValue = currentValue;
      this.lastTrainerSalesKPIValue = lastValue.toString();
      this.diffTrainerSalesKPIValue = lastValue.toString();
      this.trainerSalesStatus = "newMemberDown";
    }
    else if (currentValue == undefined && lastValue == undefined) {
      this.currentTrainerSalesKPIValue = currentValue;
      this.lastTrainerSalesKPIValue = lastValue;
      this.diffTrainerSalesKPIValue = "0";
      this.trainerSalesStatus = "NoDiff";
    }
    else {
      this.currentTrainerSalesKPIValue = currentValue.toString();
      this.lastTrainerSalesKPIValue = lastValue.toString();

      if (currentValue > lastValue) {
        let diff = currentValue - lastValue;
        this.diffTrainerSalesKPIValue = diff.toString();
        this.trainerSalesStatus = "salesTrainerUp";
      }
      else if (lastValue > currentValue) {
        let diff = lastValue - currentValue;
        this.diffTrainerSalesKPIValue = diff.toString();
        this.trainerSalesStatus = "salesTrainerDown";
      }
      else {
        this.diffTrainerSalesKPIValue = "0";
        this.trainerSalesStatus = "NoDiff";
      }
    }

  }

  drawPOSSaleKpi(currentValue: any, lastValue: any) {
    if (lastValue == undefined && currentValue != undefined) {
      this.currentPOSSalesKPIValue = currentValue.toString();
      this.lastPOSSalesKPIValue = "No Data";
      this.diffPOSSalesKPIValue = currentValue.toString();
      this.posSalesStatus = "salesTrainerUp";
    }
    else if (currentValue == undefined && lastValue != undefined) {
      this.currentPOSSalesKPIValue = "No Data";
      this.lastPOSSalesKPIValue = lastValue.toString();
      this.diffPOSSalesKPIValue = lastValue.toString();
      this.posSalesStatus = "salesTrainerDown";
    }
    else if (currentValue == undefined && lastValue == undefined) {
      this.currentPOSSalesKPIValue = "No Data";
      this.lastPOSSalesKPIValue = "No Data";
      this.diffPOSSalesKPIValue = "0";
      this.posSalesStatus = "NoDiff";
    }
    else {
      this.currentPOSSalesKPIValue = currentValue.toString();
      this.lastPOSSalesKPIValue = lastValue.toString();

      if (currentValue > lastValue) {
        const diff = currentValue - lastValue;
        this.diffPOSSalesKPIValue = diff.toString();
        this.posSalesStatus = "salesTrainerUp";
      }
      else if (lastValue > currentValue) {
        const diff = lastValue - currentValue;
        this.diffPOSSalesKPIValue = diff.toString();
        this.posSalesStatus = "salesTrainerDown";
      }
      else {
        this.diffPOSSalesKPIValue = "0";
        this.posSalesStatus = "NoDiff";
      }
    }
  }

  showChurnRateChart(){
    this.expandChurnRateKPI = !this.expandChurnRateKPI;
    this.kpiMainState = this.expandChurnRateKPI ? "transformed" : "";
  }

  onChange(){
    this.getUpdatedData();
    if (this.showChurnRateCard) {
      this.getChurnRateData();
    }
    this.getTotalSalesData();
    this.getTotalPosSales();
    this.getNewMembersStats();
    this.getDayPassStats();
    this.getFrozenMemberStats();
    this.getAttendanceData();
    this.getActiveMembersStatus();
    this.getTrainerStatus();
    this.getMonthWiseSalesChartData();
    this.getPackageWiseSalesChartData();
    this.getNewMembersRegisteredChartData();

  }

  getUpdatedData(){
    this.loading = true;
    this.appServiceManager.get(
      `branches/${this.branch._id}/stats-dashboards/reports/month-stats/month/${this.monthValue}/year/${this.yearValue}`,
    ).subscribe(
      (res: any) => {
          if (res) {
            if(res.length > 0 ){
              this.data = res[0];
              this.data.activemembersthismonth = this.data.activeCustomers - this.data.defaulters;
              this.loading=false;
            }
            else{
              this.data = {
                totalSales: 0,
                newMemberRegistered: 0,
                defaulters: 0,
                activeCustomers: 0,
                activemembersthismonth: 0,
                visitors: 0,
                enquiries: 0,
                totalPosSales: 0,
              };
              this.loading=false;
            }

        } else {
          this.loading=false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error: any) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }


  getChurnRateData(){
    this.loading = true;
    this.appServiceManager.get(
      `branches/${this.branch._id}/stats-dashboards/reports/churn-rate-data/month/${this.monthValue}/year/${this.yearValue}`,
    ).subscribe(
      (res: any) => {
          if (res) {

              this.drawChurnRateChart(res.currentMonthChurn, res.previousMonthChurn);
              this.drawChurnRateKpi(res.previousMonthChurn, res.currentMonthChurn);
              this.loading=false;

        } else {
          this.loading=false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error: any) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  getTotalSalesData() {
    this.loading = true;
    this.appServiceManager.get(
      `branches/${this.branch._id}/stats-dashboards/reports/total-sales-data/month/${this.monthValue}/year/${this.yearValue}`,
    ).subscribe(
      (res: any) => {
        if (res) {
          this.drawSalesKpi(res.currentMonthSales, res.previousMonthSales)
          this.loading = false;

        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error: any) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  getTotalPosSales() {
    this.loading = true;
    const year = Number(this.yearValue);
    const month = Number(this.monthValue);
    const from = new Date(year, month - 1, 1);
    const to = new Date(year, month, 0);
    const formatDate = (d: Date) =>
      d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
    const fromDateStr = formatDate(from);
    const toDateStr = formatDate(to);
    const baseUrl = `branches/${this.branch._id}/sale-orders/reports/by-filters/from/${fromDateStr}/to/${toDateStr}/status`;

    forkJoin({
      fulfilled: this.appServiceManager.get(`${baseUrl}/fulfilled`),
      payLater: this.appServiceManager.get(`${baseUrl}/payLater`).pipe(catchError(() => of([]))),
      products: this.appServiceManager.get(`branches/${this.branch._id}/products`).pipe(catchError(() => of([]))),
    }).subscribe(
      (result: any) => {
        const fulfilled = Array.isArray(result.fulfilled) ? result.fulfilled : [];
        const payLater = Array.isArray(result.payLater) ? result.payLater : [];
        const catalogProducts = Array.isArray(result.products) ? result.products : [];
        const byId = new Map<string, any>();
        [...fulfilled, ...payLater].forEach((order: any) => {
          if (!order?._id) {
            return;
          }
          const existing = byId.get(order._id);
          if (!existing) {
            byId.set(order._id, order);
            return;
          }
          const existingPaid = Number(existing.paid) || 0;
          const nextPaid = Number(order.paid) || 0;
          if (nextPaid >= existingPaid) {
            byId.set(order._id, order);
          }
        });
        const posSales = Array.from(byId.values()).filter((order: any) => order.status == 'POS');
        this.totalPosSales = posSales.reduce((acc: number, order: any) => acc + (Number(order.total) || 0), 0);
        const posProfitResult = this.calculatePosProfit(posSales, catalogProducts);
        this.totalPosProfit = posProfitResult.profit;
        this.showPosNetProfit = posProfitResult.show;
        this.loading = false;
      },
      (error: any) => {
        this.totalPosSales = 0;
        this.totalPosProfit = 0;
        this.showPosNetProfit = false;
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  calculatePosProfit(posSales: any[], catalogProducts: any[] = []): { profit: number; show: boolean } {
    const productsById = new Map<string, any>();
    const productsByCode = new Map<string, any>();
    (catalogProducts || []).forEach((product: any) => {
      if (product?._id) {
        productsById.set(String(product._id), product);
      }
      if (product?.code != null && product.code !== '') {
        productsByCode.set(String(product.code), product);
      }
    });

    let hasZeroPurchasePrice = false;
    const profit = (posSales || []).reduce((totalProfit: number, order: any) => {
      const soldProducts = Array.isArray(order?.products) ? order.products : [];
      const orderProfit = soldProducts.reduce((productProfit: number, soldProduct: any) => {
        const catalogProduct = productsById.get(String(soldProduct?._id || soldProduct?.productId || ''))
          || productsByCode.get(String(soldProduct?.code || ''));
        const cost = Number(soldProduct?.cost ?? catalogProduct?.cost);
        const unitPrice = Number(soldProduct?.unitPrice) || 0;
        if (!cost) {
          hasZeroPurchasePrice = true;
          return productProfit;
        }
        if (!unitPrice) {
          return productProfit;
        }
        const quantity = Number(soldProduct?.quantity) || 1;
        return productProfit + ((unitPrice - cost) * quantity);
      }, 0);
      return totalProfit + orderProfit;
    }, 0);

    return {
      profit,
      show: !hasZeroPurchasePrice && profit !== 0
    };
  }

  getDayPassStats() {
    this.loading = true;
    this.appServiceManager.get(
      `branches/${this.branch._id}/stats-dashboards/reports/day-pass-stats/month/${this.monthValue}/year/${this.yearValue}`,
    ).subscribe(
      (res: any) => {
        if (res) {
          this.drawDayPassKpi(res.currentMonthVisitors, res.previousMonthVisitors);
          this.loading = false;

        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error: any) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  getNewMembersStats() {
    this.loading = true;
    this.appServiceManager.get(
      `branches/${this.branch._id}/stats-dashboards/reports/new-members-stats/month/${this.monthValue}/year/${this.yearValue}`,
    ).subscribe(
      (res: any) => {
        if (res) {
          this.drawNewMembersKpi(res.currentMonthNewMembers, res.previousMonthNewMembers);
          this.loading = false;

        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error: any) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  getFrozenMemberStats() {
    this.loading = true;
    this.appServiceManager.get(
      `branches/${this.branch._id}/stats-dashboards/reports/frozen-member-stats/month/${this.monthValue}/year/${this.yearValue}`,
    ).subscribe(
      (res: any) => {
        if (res) {
          this.drawMembershipFrozenKpi(res.currentMonthFrozenMembers, res.previousMonthFrozenMembers);
          this.loading = false;

        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error: any) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  getTrainerStatus(){
    this.loading = true;
    this.appServiceManager.get(
      `branches/${this.branch._id}/stats-dashboards/reports/trainer-status/month/${this.monthValue}/year/${this.yearValue}`,
    ).subscribe(
      (res: any) => {
          if (res) {
              this.drawTrainerSaleKpi(res.currentTotal, res.previousTotal);
              this.loading=false;

        } else {
          this.loading=false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error: any) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  getActiveMembersStatus(){
    this.loading = true;
    this.appServiceManager.get(
      `branches/${this.branch._id}/stats-dashboards/reports/active-members-status/month/${this.monthValue}/year/${this.yearValue}`,
    ).subscribe(
      (res: any) => {
          if (res) {
              this.drawActiveMembersKpi(res.currentMonthActiveMembers, res.prevMonthActiveMembers);
              this.loading=false;

        } else {
          this.loading=false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error: any) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  getMonthWiseSalesChartData() {
    this.loading = true;
    this.appServiceManager.get(
      `branches/${this.branch._id}/stats-dashboards/reports/month-wise-sales-chart-data/month/${this.monthValue}/year/${this.yearValue}`,
    ).subscribe(
      (res: any) => {
        if (res) {
          this.currentYearSales = res.currentYearData;
          this.previousYearSales = res.previousYearData;
          this.currentYear = res.currentYear;
          this.previousYear = res.previousYear;
          this.drawMonthWiseSaleChart();
          this.loading = false;

        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error: any) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  getPackageWiseSalesChartData() {
    this.loading = true;
    this.appServiceManager.get(
      `branches/${this.branch._id}/stats-dashboards/reports/package-wise-sales-chart-data/month/${this.monthValue}/year/${this.yearValue}`,
    ).subscribe(
      (res: any) => {
        if (res) {
          this.drawPackageWiseSales(res.topFivePackages);
          this.totalPackageAmountForChart = res.packageTotal;
          this.loading = false;

        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error: any) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  getNewMembersRegisteredChartData() {
    this.loading = true;
    this.appServiceManager.get(
      `branches/${this.branch._id}/stats-dashboards/reports/new-members-registered-chart-data/month/${this.monthValue}/year/${this.yearValue}`,
    ).subscribe(
      (res: any) => {
        if (res) {
          this.drawNewMembersRegisteredChart(res.topFivePackages);
          this.NewMembersRegisteredCount = res.totalCount;
          this.loading = false;

        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error: any) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  getTotalActiveMembersStatus() {
    this.loading = true;
    this.appServiceManager.get(
      `branches/${this.branch._id}/stats-dashboards/reports/total-active-members-status/month/${this.monthValue}/year/${this.yearValue}`,
    ).subscribe(
      (res: any) => {
        if (res) {
          this.drawActiveMembersChart(res.activeMembersData);
          this.loading = false;

        } else {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error: any) => {
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      }
    );
  }

  setLabel(label: string) {
    return this.LanguageService.GetCurrentLanguage("DashboardComponent", label);
  }
}
